export default {
    items: {
        data: null
    },
    all: {
        data: null
    }
}